import React from 'react';
import AuditForm from '../components/sections/AuditForm';
import SEO from '../components/common/SEO';
import SafeIcon from '../components/common/SafeIcon';
import { FiCheck } from 'react-icons/fi';

const AuditPage = () => {
  return (
    <>
      <SEO 
        title="Free SEO Audit | Alberta SEO Pro"
        description="Get a comprehensive video audit of your website's SEO performance. Find out why you aren't ranking #1 in Calgary, Edmonton, or Red Deer."
      />
      
      <div className="bg-slate-50 min-h-screen pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-4">Get Your Free Website Analysis</h1>
            <p className="text-xl text-slate-600">Discover missed opportunities and hidden technical errors.</p>
          </div>

          <div className="grid md:grid-cols-5 gap-8 bg-white rounded-2xl shadow-xl overflow-hidden">
             <div className="md:col-span-2 bg-slate-900 p-8 text-white flex flex-col justify-center">
                <h3 className="text-xl font-bold mb-6">What You'll Get:</h3>
                <ul className="space-y-4">
                  {[
                    "Video walkthrough of your site",
                    "Competitor keyword analysis",
                    "Technical error report",
                    "Actionable step-by-step plan",
                    "AEO readiness score"
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <SafeIcon icon={FiCheck} className="text-green-400 mt-1 shrink-0" />
                      <span className="text-slate-300 text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
             </div>
             <div className="md:col-span-3 p-8">
                <AuditForm />
             </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuditPage;